import { EventState } from './types'

export const eventTypesNeedLoading = (state: EventState) =>
  !state.meta.FETCH_EVENT_TYPES.loaded

export const allEventTypes = (state: EventState) =>
  Object.values(state.eventTypes)
